import * as React from 'react'

import styles from './EditableLabel.pcss'

export interface EditableLabelProps {
  value: string
  editMode: boolean
  allowEmpty?: boolean
  inputClassName?: string
  className?: string
  onChange: (name: string | undefined) => any
}

export function EditableLabel(props: EditableLabelProps) {
  const [value, setValue] = React.useState<string>(props.value)
  const inputRef = React.useRef<HTMLInputElement | null>(null)
  const prevEditModeRef = React.useRef<boolean>(props.editMode)

  React.useEffect(() => {
    if (props.editMode && !prevEditModeRef.current && inputRef.current) {
      inputRef.current.focus()
      inputRef.current.selectionStart = props.value.length
    }
    prevEditModeRef.current = props.editMode
  }, [props.editMode, props.value])

  const onValueChanged = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const newVal = e.target.value
    setValue(newVal)
  }, [])

  const cancelChanges = React.useCallback(() => {
    setValue(props.value)
    props.onChange(undefined)
  }, [props])

  const saveChanges = React.useCallback(() => {
    const newValue = value.trim()
    if (!props.allowEmpty && newValue === '' || newValue === props.value) {
      setValue(props.value)
      props.onChange(undefined)
      return
    }
    props.onChange(newValue)
  }, [value, props])

  const onKeyDown = React.useCallback((e: any) => {
    const enterKeyCode = 13
    const escapeKeyCode = 27

    if (e.keyCode === enterKeyCode) {
      if (inputRef.current) inputRef.current.blur()
    }

    if (e.keyCode === escapeKeyCode) {
      cancelChanges()
    }
  }, [cancelChanges])

  return (
    <div className={`text-ellipsis ${props.className || ''}`}>
      <span className={`${props.editMode ? styles.hidden : ''}`}>{value}</span>
      <input
        className={`${styles.input} ${props.inputClassName || ''} ${!props.editMode ? styles.hidden : ''}`}
        type="text"
        value={value}
        ref={inputRef}
        onChange={onValueChanged}
        onKeyDown={onKeyDown}
        onBlur={saveChanges}
        readOnly={!props.editMode}
      />
    </div>
  )
}

export default EditableLabel
